import { useContext } from "react";
import { ControlContext } from "../ControlContext.jsx";
import ChangeDepths from "../Helpers/ChangeDepths.jsx";

import Dibond from "./FrameComp/Dibond.jsx";
import Glass from "./FrameComp/Glass";

export default function FaceMount() {
  const { faceMountFinish, chromaluxeType } =
    useContext(ControlContext);

  const { dibondDepth, glassDepth } = ChangeDepths();

  const glassRender = () => {
    if (
      faceMountFinish === "Perspex" ||
      chromaluxeType === "ChrMetalicGlossy" ||
      chromaluxeType === "ChrMetalicMatt"
    ) {
      return <Glass glassDepth={glassDepth} />;
    }
  };

  return (
    <>
      <Dibond depth={dibondDepth} />
      {glassRender()}
    </>
  );
}
